import { Dialog } from '@mui/material';

import { RetailerNetworkUserCreate } from '@occc/graphql';

import { RetailerNetworkUsersListContainer } from './retailer-network-users-list/retailer-network-users-list.container';

type RetailerNetworkAddExistingUserDialogProps = {
  open: boolean;
  onClose: () => void;
  retailerNetworkUpdate: (newRetailerNetworkUsers: RetailerNetworkUserCreate[]) => Promise<void>;
};

export const RetailerNetworkAddExistingUserDialog = ({
  open,
  onClose,
  retailerNetworkUpdate,
}: RetailerNetworkAddExistingUserDialogProps) => {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <RetailerNetworkUsersListContainer
        retailerNetworkUpdate={retailerNetworkUpdate}
        onClose={onClose}
      />
    </Dialog>
  );
};
